import { render } from "./pdf-component.vue?vue&type=template&id=999b7902&ts=true"
import script from "./pdf-component.vue?vue&type=script&lang=ts"
export * from "./pdf-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__